import DateFnsUtils from '@date-io/date-fns';
import {Box, Button, FormControlLabel, Radio, RadioGroup, Snackbar, Typography} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {useState} from 'react';
import {ExportToCsv} from 'ts-export-to-csv';
import API from '../APIs/API';

function CircularProgressWithLabel(props: any) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="determinate" {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}
export default function ClientDataAnalytics() {
    let [data, setData] = useState([]);
    const [clicked, setClicked] = useState(false);
    const [optionChecked, setOptionChecked] = useState('a');
    let [color, setColor] = useState('secondary');
    let [selectedDate, setSelectedDate] = useState({
        startDate: new Date(new Date().getTime() - 6 * 24 * 3600 * 1000),
        endDate: new Date(),
    });
    let [percentDownloaded, setPercentDownloaded] = useState(-1);
    let [showToaster, setShowToaster] = useState(false);
    let [showToasterDownload, setShowToasterDownload] = useState(false);
    let [renderMe, setRenderMe] = useState(true);
    function handleChange(e: any) {
        setOptionChecked(e.target.value === 'past-week' ? 'a' : 'b');
    }
    function handleOnClose() {
        setShowToaster(false);
    }
    async function generateCSV() {
        let queryData = await getDataFnc();
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title:
                optionChecked === 'a'
                    ? 'Weekly Client Data Report'
                    : `Client Data Report From ${
                          selectedDate.endDate.getMonth() + 1
                      }/${selectedDate.endDate.getDate()}/${selectedDate.endDate.getFullYear()} to ${
                          selectedDate.startDate.getMonth() + 1
                      }/${selectedDate.startDate.getDate()}/${selectedDate.startDate.getFullYear()}`,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename:
                optionChecked === 'a'
                    ? 'Weekly Client Data Report'
                    : `Client Data Report From ${
                          selectedDate.endDate.getMonth() + 1
                      }/${selectedDate.endDate.getDate()}/${selectedDate.endDate.getFullYear()} to ${
                          selectedDate.startDate.getMonth() + 1
                      }/${selectedDate.startDate.getDate()}/${selectedDate.startDate.getFullYear()}`,
        };
        setData(queryData);
        setShowToasterDownload(true);
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(queryData);
    }
    function dateValidation() {
        if (selectedDate.startDate > selectedDate.endDate) {
            setShowToaster(true);
            return false;
        }
        return true;
    }
    function handleDateChangeStart(e: any) {
        setSelectedDate({
            ...selectedDate,
            startDate: e,
        });
        dateValidation();
    }
    function handleDateChangeEnd(e: any) {
        setSelectedDate({
            ...selectedDate,
            endDate: e,
        });
        dateValidation();
    }
    async function getDataFnc() {
        setPercentDownloaded(0);
        if (optionChecked === 'a') {
            let tempObj = {
                endDate: new Date(),
                startDate: new Date(),
            };
            tempObj.endDate = new Date();
            tempObj.startDate = new Date(tempObj.endDate.getTime() - 7 * 24 * 3600 * 1000);
            selectedDate = tempObj;
            setSelectedDate(tempObj);
        }
        let queryData: any = [];
        let st = selectedDate.startDate.getTime();
        const end = selectedDate.endDate.getTime();
        const totalNumberOfdays = Math.ceil((end - st) / (24 * 3600 * 1000));
        for (let iter = st, i = 0; iter <= end; iter = iter + 24 * 3600 * 1000, i++) {
            const tempDate = new Date(iter);
            let sday = tempDate.getDate();
            let smonth = tempDate.getMonth() + 1;
            const sendData = {
                startDateString:
                    tempDate.getFullYear() +
                    '-' +
                    (smonth < 10 ? '0' + smonth : `${smonth}`) +
                    '-' +
                    (sday < 10 ? '0' + sday : `${sday}`),
                endDateString:
                    tempDate.getFullYear() +
                    '-' +
                    (smonth < 10 ? '0' + smonth : `${smonth}`) +
                    '-' +
                    (sday < 10 ? '0' + sday : `${sday}`),
            };
            let tempData = await API.Call('client-data', 'POST', sendData);
            tempData = tempData == null || tempData == undefined ? [] : tempData;
            queryData = queryData.concat(tempData);
            setPercentDownloaded(((i + 1) / totalNumberOfdays) * 100);
        }
        setPercentDownloaded(-1);
        return queryData;
    }
    function handleOnCloseDownload() {
        setShowToasterDownload(false);
    }
    return (
        <Grid container justify={'space-between'} alignItems={'center'}>
            <RadioGroup aria-label="type" name="type1">
                <FormControlLabel
                    value="past-week"
                    control={<Radio checked={optionChecked == 'a'} onChange={handleChange} />}
                    label="Last Week"
                    labelPlacement="start"
                />
                <FormControlLabel
                    value="custom-range"
                    control={<Radio checked={optionChecked == 'b'} onChange={handleChange} />}
                    label="Custom Range"
                    labelPlacement="start"
                />
            </RadioGroup>
            {optionChecked === 'a' ? null : (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="start-date"
                        label="Start Date"
                        value={selectedDate.startDate}
                        onChange={handleDateChangeStart}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="end-date"
                        label="End Date"
                        value={selectedDate.endDate}
                        onChange={handleDateChangeEnd}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            )}
            <div>
                {percentDownloaded < 0 ? (
                    <Button variant="contained" color="primary" onClick={generateCSV} style={{maxHeight: '25px'}}>
                        Download Report
                    </Button>
                ) : (
                    <CircularProgressWithLabel value={percentDownloaded} />
                )}
            </div>
            <Snackbar open={showToaster} autoHideDuration={3000} onClose={handleOnClose}>
                <MuiAlert elevation={6} variant="filled" severity="error" onClose={handleOnClose}>
                    The Start date can't be smaller than the End date
                </MuiAlert>
            </Snackbar>
            <Snackbar open={showToasterDownload} autoHideDuration={3000} onClose={handleOnCloseDownload}>
                <MuiAlert elevation={6} variant="filled" severity="success" onClose={handleOnCloseDownload}>
                    Data Fetch Successful! Now you can click download button for CSV report.
                </MuiAlert>
            </Snackbar>
        </Grid>
    );
}
